import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
    standalone: false
})
export class CapitalizePipe implements PipeTransform {

  transform(value?: string, ...args: unknown[]): unknown {
    if(value == null)
      return null;

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

}
